export default __webpack_public_path__ + "8337b01505ced57c04bc2ca825c8effc.svg";